import React, { useEffect, useMemo, useRef, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Get_server_time, Get_test, Get_test_details } from "../../gql/queries";
import { Bookmark_QB, Report_Submit, Result_Submit } from "../../gql/mutation";
import { getLocalStorage, getLocalStorageQuestions, getTestTime, setLocalStorage, transform } from "../../utils";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { firebaseData } from "../../firebase";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import Question from "./sections/Question";
import AnswerPalette from "./sections/AnswerPalette";
import UserDetail from "./sections/UserDetail";
import QuestionPaperModal from "./sections/QuestionPaperModal";
import TimeCounter from "./sections/TimeCounter";
const INITIAL_STATE = {
    contentType: "",
    userFeedBack: "",
    category: "",
    contentId: ''
};

const REACT_APP_IMAGE_URL = 'https://dbmi-data.s3.ap-south-1.amazonaws.com/'

const INITIAL_DATA = {
    questionId: "",
    isView: true,
    isReview: false,
    isGuessed: false,
    isSave: false,
    answer: "",
}

export default function TestFlowAttempt() {


    // useEffect(() => {
    //     if (!navigator.onLine) {
    //         showToastError("Please check your internet connection and try again")
    //         return
    //     }
    //     window.history.pushState(null, null, window.location.href);
    //     window.onpopstate = function () {
    //         setTestSubmitModal(false)
    //         setConfirmationModal(true)
    //         window.history.pushState(null, null, window.location.href);

    //     };
    // }, []);


    // useEffect(() => {
    //     window.addEventListener("beforeunload", function (e) {
    //         var confirmationMessage = "\o/";
    //         (e || window.event).returnValue = confirmationMessage;     //Gecko + IE
    //         return confirmationMessage;                                //Webkit, Safari, Chrome etc.
    //     });
    // }, []);


    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function () {
            setTestSubmitModal(false)
            setConfirmationModal(true)
            window.history.pushState(null, null, window.location.href);

        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                console.log("Tab changed");
            } else {
                console.log("Tab active");
                window.location.reload();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    useEffect(() => {
        window.addEventListener("beforeunload", function (e) {
            var confirmationMessage = "\o/";
            (e || window.event).returnValue = confirmationMessage;     //Gecko + IE
            return confirmationMessage;                                //Webkit, Safari, Chrome etc.
        });
    }, []);


    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation();

    // const query1 = useQuery(Get_test, {
    //     variables: {
    //         "_id": id,
    //     },
    // });

    const query1 = useQuery(Get_test_details, {
        variables: {
            "_id": id,
        },
    });

    const query2 = useQuery(Get_server_time, {
        // fetchPolicy: 'network-only'
    })

    const [report] = useMutation(Report_Submit)
    const [resultSubmit] = useMutation(Result_Submit);
    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: Get_test,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'test' // Query name,

        ],
    });

    const testDetail = query1?.data?.test || {};
    const mainQuestions = query1?.data?.test?.questions || [];
    const [isLoading, setIsLoading] = useState(false)
    let timerId = 0

    const [mainLoading, setMainLoading] = useState(false)

    //calculate remaining time and section index
    const remainTimeCalculator = () => {
        // clearInterval(timerId);
        if (testDetail && testDetail.serverTime) {
            const duration = parseInt(testDetail.duration);
            const totalSection = testDetail.noOfSections || 1;
            const perSectionTime = (duration / totalSection) * 60;
            const serverdateTime = new Date(testDetail.serverTime);
            let nextSection = 0;
            let remainTime = 0;
            if (testDetail.progress && testDetail.progress.startTime && !isNaN(serverdateTime.getTime())) {
                const startTime = moment(testDetail.progress.startTime); //  start time
                // const endTime = moment().utc();   //  curent time
                const endTime = moment(testDetail.serverTime);   //  curent time

                const consumedDuration = moment.duration(endTime.diff(startTime));
                const minutes = consumedDuration.asMinutes();
                //console.log(testDetail?.serverTime, testDetail.progress.startTime, "server time and start time");



                let durationPassed = minutes * 60
                if (durationPassed < (duration * 60)) {
                    let SectionIndex = Math.ceil(durationPassed / perSectionTime)
                    nextSection = SectionIndex - 1
                    let sectionDurationPassed = durationPassed - (SectionIndex - 1) * perSectionTime
                    remainTime = perSectionTime - sectionDurationPassed
                } else {
                    nextSection = totalSection - 1;
                    remainTime = 0;
                }

            } else {
                nextSection = 0;
                remainTime = perSectionTime;
            }

            // set calculated section index in local
            let curentIndxing = JSON.parse(localStorage.getItem(`test${id}`))
            if (curentIndxing && curentIndxing.section == nextSection) {
                localStorage.setItem(`test${id}`, JSON.stringify({ index: curentIndxing.index, section: nextSection }))
                setIndex(curentIndxing.index)
            } else {
                localStorage.setItem(`test${id}`, JSON.stringify({ index: 0, section: nextSection }))
                setIndex(0)
            }
            //generate new entry for attempted question and save in local
            const cloneAttemptedQuestion = getLocalStorageQuestions(id)
            let curentIndxingLocal = JSON.parse(localStorage.getItem(`test${id}`))
            //console.log("local question indexing", (nextSection * (mainQuestions.length / totalSection)) + curentIndxingLocal.index);
            if (!cloneAttemptedQuestion[parseInt(nextSection * (mainQuestions.length / totalSection)) + curentIndxingLocal.index]?.questionId) {
                cloneAttemptedQuestion[parseInt(nextSection * (mainQuestions.length / totalSection)) + curentIndxingLocal.index] = { ...INITIAL_DATA, currentSection: nextSection }

            }
            setAttemptedQuestions(cloneAttemptedQuestion)
            //set current section 
            setCurrentSection(nextSection)
            console.log({ index: nextSection, time: remainTime }, " index: nextSection, time: remainTime");
            return { index: nextSection, time: remainTime, perSectionTime };

        }

        return { index: 0, time: 0 }; // Default values if testDetail is not available or invalid
    }





    const [questionPaperModal, setQuestionPaperModal] = useState(false);
    const [viewInstrutionsModal, setViewInstrutionsModal] = useState(false);
    const [testSubmitModal, setTestSubmitModal] = useState(false);

    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [profileDetails] = useState(getLocalStorage('profileDetails'));
    const [attemptedQuestions, setAttemptedQuestions] = useState(getLocalStorageQuestions(id) || [])
    // let time = getRemainingTime() ? getRemainingTime() : 0;
    // console.log(time, "initial time");
    // const [counter, setCounter] = useState(0);

    const timerRef = useRef(0)
    const countRef = useRef(0)

    const [sectionCounter, setSectionCounter] = useState(0)

    const [confirmationModal, setConfirmationModal] = useState(false);
    const [testQuitModal, setTestQuitModal] = useState(false);

    const [displayImageModal, setDisplayImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [totalSection, setTotalSection] = useState(testDetail.noOfSections && testDetail.noOfSections > 1 ? testDetail?.noOfSections : 1);
    // const [totalSection, setTotalSection] = useState(2);
    const [showSection, setShowSection] = useState(false)
    const [currentSection, setCurrentSection] = useState(0);
    const [eachSectionQuestion, setEachSectionQuestion] = useState(0)//number of question in each section
    const [sectionWiseQuestion, setSectionWiseQuestion] = useState([])
    let curentIndxing = JSON.parse(localStorage.getItem(`test${id}`))
    const imgHide = () => setDisplayImageModal(false);
    const [index, setIndex] = useState(curentIndxing && curentIndxing.section == currentSection ? curentIndxing.index : 0);
    // const [index, setIndex] = useState(0);
    // setIndex(localStorage.getItem(`test${id}`) ? (localStorage.getItem(`test${id}`) > eachSectionQuestion ? localStorage.getItem(`test${id}`) - eachSectionQuestion : 0) : 0)
    const openImageModal = (img) => {
        setDisplayImageModal(true);
        setSelectedImage(img);
    };

    useEffect(() => {
        // setCurrentSection(remainTimeCalculator().index)
        if (countRef.current === 0 && testDetail?.progress?.startTime) {
            setTotalSection(testDetail?.noOfSections ? testDetail?.noOfSections : 1)
            setShowSection(testDetail?.noOfSections > 1 ? true : false)
            let remainTime = remainTimeCalculator().time
            //console.log("qwerty", remainTimeCalculator())
            console.log("data time ref 2", parseInt(remainTime > 0 ? remainTime : 0))

            timerRef.current = parseInt(remainTime > 0 ? remainTime : 0);
            countRef.current++
            setSectionCounter(remainTime > 0 ? remainTime : 0)
            if (remainTime <= 0) {
                if (testSubmitModal) {
                    setTestSubmitModal(false)
                }
                setTestQuitModal(true)
                return

            }
        }
    }, [testDetail?.progress?.startTime, testDetail?.duration])


    const showToast = (message) => {
        toast.success(message);
    };

    const showToastError = (message) => {
        toast.error(message);
    };
    const sectionNumbers = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

    // save data filter of attempted question
    const finalSavedQuestion = useMemo(() => {
        return attemptedQuestions.filter(item => item?.questionId).map((item) => {
            return {
                userAnswer: item.answer || '',
                questionId: item?.questionId,
                isReview: item?.isReview,
                isGuessed: item?.isGuessed
            }
        })
    }, [attemptedQuestions])

    // console.log(finalSavedQuestion);

    const getResumeTestTime = (server, start, duration) => {
        const startdateTime = new Date(start);
        const serverdateTime = new Date(server);
        const timeDifferenceInMilliseconds = Math.abs(serverdateTime - startdateTime);
        const totalduration = (timeDifferenceInMilliseconds / 1000);
        let resumeTime = ((parseInt(duration) - (totalduration / 60)))
        resumeTime = resumeTime * 60
        resumeTime = (parseInt(duration) * 60) - resumeTime
        return resumeTime

    }
    // next handler
    const questionNextHandler = (attemptData = {}) => {
        localStorage.setItem(`test${id}`, JSON.stringify({ index: index, section: currentSection }))
        const tempAttemptData = [...attemptedQuestions]
        if (totalSection > 1) {
            if ((index + 1) === eachSectionQuestion && sectionCounter > 0 && totalSection > 1 && totalSection > currentSection) {
                tempAttemptData[(currentSection * eachSectionQuestion) + index] = attemptData;
                setAttemptedQuestions(tempAttemptData)
                // if (totalSection == currentSection + 1) {
                //     showToastError("Please review your questions of current section till timer gets off")
                // } else {
                //     showToastError("You will be moved to next section automatically after current section timer gets over.")
                //     // showToastError("Please review your questions of current section till timer gets off")

                // }

                return
            }
            if ((index + 1) === eachSectionQuestion && sectionCounter > 0 && totalSection <= 1) {
                tempAttemptData[(currentSection * eachSectionQuestion) + index] = attemptData;
                setAttemptedQuestions(tempAttemptData)
                showToastError("Please review your questions of current section till timer gets off")
                return
            }
            // if ((index + 1) === eachSectionQuestion && (currentSection + 1) < totalSection) {
            //     curentSectionHandler(currentSection + 1)
            //     return
            // }
        } else {
            if ((index + 1) === eachSectionQuestion)
                tempAttemptData[(currentSection * eachSectionQuestion) + index] = attemptData;
            setAttemptedQuestions(tempAttemptData)

        }
        // if()

        if (mainQuestions?.length > (index + 1)) {
            setIndex(index + 1)
            if (!tempAttemptData[(currentSection * eachSectionQuestion) + index + 1]?.questionId) {
                tempAttemptData[(currentSection * eachSectionQuestion) + index + 1] = { ...INITIAL_DATA, currentSection: currentSection };
            }
        }
        tempAttemptData[(currentSection * eachSectionQuestion) + index] = attemptData;
        setAttemptedQuestions(tempAttemptData)

    }

    //previous handler
    const questionPreviousHandler = () => {
        if (index >= 1) {
            setIndex(index - 1)
        }
    }

    // switch question for tapping on number
    const switchQuestion = (ind, questionId = "") => {
        setIndex(ind)
        const tempAttemptData = [...attemptedQuestions]
        tempAttemptData[(currentSection * eachSectionQuestion) + ind] = {
            questionId,
            isView: true,
            isReview: false,
            isGuessed: false,
            isSave: false,
            answer: "", ...tempAttemptData[(currentSection * eachSectionQuestion) + ind],
            currentSection: currentSection
        };
        setAttemptedQuestions(tempAttemptData)
    }

    const viewPerformance = async () => {
        try {
            const response = await query2.refetch();


            if (response && response?.data) {
                const startTime = query1?.data?.test?.progress?.startTime;
                const serverTime = response?.data?.serverTime;

                const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
                const duration = parseFloat(resumeTestTime.toFixed(1));

                const resultInput = {
                    qbId: query1?.data?.test?._id,
                    resultType: "Test",
                    startTime: startTime,
                    endTime: serverTime,
                    duration: duration,
                    questions: finalSavedQuestion,
                    questionInterval: 0.0,
                    category: query1?.data?.test?.category,
                    isCompleted: true,
                    subjectId: query1?.data?.test?.subject,
                    topicId: query1?.data?.test?.subjectDetail?.topicId,
                    courseName: profileDetails?.preparingFor,
                };


                localStorage.removeItem(id)
                localStorage.removeItem(`test${id}`)


                // Now, call resultSubmit only after ensuring that query2.data is available
                resultSubmit({ variables: { resultInput } });
                navigate(`/testlayer/testperformance/${id}`);
            }
        } catch (error) {
            // Handle any errors that occur during the refetch or resultSubmit process
            console.error("Error:", error);
        }
    };


    const totalresult = async () => {
        try {
            // Use await to ensure that query2.refetch() is completed before proceeding
            const response = await query2.refetch();


            if (response && response?.data) {
                const startTime = query1?.data?.test?.progress?.startTime;
                const serverTime = response?.data?.serverTime;

                const resumeTestTime = getResumeTestTime(serverTime, startTime, query1?.data?.test?.duration);
                const duration = parseFloat(resumeTestTime.toFixed(1));

                const resultInput = {
                    qbId: query1?.data?.test?._id,
                    resultType: "Test",
                    startTime: startTime,
                    endTime: serverTime,
                    duration: duration,
                    questions: finalSavedQuestion,
                    questionInterval: 0.0,
                    category: query1?.data?.test?.category,
                    isCompleted: true,
                    subjectId: query1?.data?.test?.subject,
                    topicId: query1?.data?.test?.subjectDetail?.topicId,
                    courseName: profileDetails?.preparingFor,
                };


                // Now, call resultSubmit only after ensuring that query2.data is available
                resultSubmit({ variables: { resultInput } });
                // if (currentSection == (totalSection - 1) && sectionCounter <= 0 && totalSection > 1) {
                localStorage.removeItem(id);
                localStorage.removeItem(`test${id}`);
                //}
                navigate(`/testlayer/testperformance/${query1.data.test._id}`);
            }
        } catch (error) {
            // Handle any errors that occur during the refetch or resultSubmit process
            console.error("Error:", error);
        }
    };

    const submitTest = async () => {
        try {
            localStorage.setItem(`test${id}`, JSON.stringify({ index: index, section: currentSection }))
            // Use await to ensure that query2.refetch() is completed before proceeding
            const response = await query2.refetch();


            if (response && response?.data) {
                const startTime = query1.data?.test?.progress?.startTime;
                const serverTime = response?.data?.serverTime;

                const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
                const duration = parseFloat(resumeTestTime.toFixed(1));

                const resultInput = {
                    qbId: query1.data?.test?._id,
                    resultType: "Test",
                    startTime: startTime,
                    endTime: serverTime,
                    duration: duration,
                    questions: finalSavedQuestion,
                    questionInterval: 0.0,
                    category: query1?.data?.test?.category,
                    isCompleted: false,
                    subjectId: query1?.data?.test?.subject,
                    topicId: query1?.data?.test?.subjectDetail?.topicId,
                    courseName: profileDetails?.preparingFor,
                };

                // Now, call resultSubmit only after ensuring that query2.data is available
                resultSubmit({ variables: { resultInput } });
                if (currentSection == (totalSection - 1) && sectionCounter <= 0 && totalSection > 1) {
                    localStorage.removeItem(`test${id}`);
                    localStorage.removeItem(id);
                }
                clearInterval(timerId)
                // setTotalSection(1)
                // setShowSection(false)
                // setCurrentSection(0);
                // setEachSectionQuestion(0)
                // setSectionWiseQuestion([])
                navigate(`/testlayer/testinstruction/${id}`)
            }
        } catch (error) {
            // Handle any errors that occur during the refetch or resultSubmit process
            console.error("Error:", error);
        }
    };


    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('report_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);

    // set one object as initial 
    useEffect(() => {
        if (attemptedQuestions?.length <= 0) {
            setAttemptedQuestions([...attemptedQuestions, { ...INITIAL_DATA, currentSection: currentSection }])
        }
    }, [])

    const curentSectionHandler = (number, click = false) => {
        console.log("number", number, currentSection)
        if (number == currentSection && click) {
            return
        }
        if (currentSection > number) {
            showToastError("You cannot move to previous section")
            return
        }
        if (number > currentSection && sectionCounter > 0 && click) {
            showToastError("You will be moved to next section automatically after current section timer gets over")
            return
        }



        if (number >= (testDetail.noOfSections ? testDetail.noOfSections : 1)) {
            if (testSubmitModal) {
                setTestSubmitModal(false)
            }
            setTestQuitModal(true)
            return

        }
        localStorage.setItem(`test${id}`, JSON.stringify({ index: index, section: number }))

        if (testDetail.noOfSections && testDetail.noOfSections > 1) {
            showToast(`Section ${sectionNumbers[number]} started`)
            console.log("timerRef.current", timerRef.current,)
            setIndex(0)
            let totalQuestion = mainQuestions.length;
            if (totalQuestion) {
                let eachSectionQuestion = totalQuestion / testDetail.noOfSections;
                let startIndex = number * (eachSectionQuestion)
                let lastIndex = eachSectionQuestion * (number + 1)
                setSectionWiseQuestion(mainQuestions.slice(startIndex, lastIndex))

            }
            setCurrentSection(number)
            console.log("data time ref 3", (testDetail?.duration / testDetail.noOfSections) * 60)
            timerRef.current = (testDetail?.duration / testDetail.noOfSections) * 60;
            const cloneAttemptedQuestion = getLocalStorageQuestions(id)
            // const cloneAttemptedQuestion = structuredClone(attemptedQuestions)           
            //adding initial data
            cloneAttemptedQuestion[number * parseInt(totalQuestion / testDetail.noOfSections)] = { ...INITIAL_DATA, currentSection: number }
            setAttemptedQuestions(cloneAttemptedQuestion)
        } else {
            setSectionWiseQuestion(mainQuestions)
        }

    }

    // save data into localstorage
    useEffect(() => {
        setLocalStorage(id, attemptedQuestions)
    }, [attemptedQuestions])

    useEffect(() => {
        timerId = remainTimeCalculator().time
        const localConfigData = JSON.parse(localStorage.getItem(`test${id}`))
        //console.log("localConfigData", localConfigData)

        if (timerRef.current <= 0 && (localConfigData.section + 1 === (testDetail.noOfSections ? testDetail?.noOfSections : 1)) && (testDetail.noOfSections ? testDetail?.noOfSections : 1) > 1) {
            curentSectionHandler(localConfigData.section + 1)
            console.log("first if")
        }
        if (timerRef.current > 0) {
            // let sectionNum = localConfigData.section;

            timerId = setInterval(() => {
                timerRef.current -= 1
                let localConfigDataBS = JSON.parse(localStorage.getItem(`test${id}`))
                let sectionNum = localConfigDataBS.section;
                // currentSectionTimer(timerRef.current)

                if (timerRef.current <= 0 && ++sectionNum <= (testDetail.noOfSections ? testDetail?.noOfSections : 1)) {
                    console.log("inner if")

                    curentSectionHandler(sectionNum)
                }

                if (timerRef.current < 0) {
                    clearInterval(timerId)
                    timerRef.current = 0
                }
                if (testDetail.noOfSections && (testDetail.noOfSections > 1)) {
                    const localConfigDataClone = JSON.parse(localStorage.getItem(`test${id}`))

                    if (document.getElementById("timer")) document.getElementById("timer").innerHTML = `Section ${sectionNumbers[localConfigDataClone.section]} Time Left : ${transform(timerRef.current)}`;
                } else {
                    if (document.getElementById("timer")) document.getElementById("timer").innerHTML = `Time Left : ${transform(timerRef.current)}`;

                }
            }, 1000);

        }

        return () => { clearInterval(timerId); timerRef.current = 0 }
    }, [testDetail?.progress?.startTime, testDetail?.duration])

    useEffect(() => {
        if (testDetail?.progress?.startTime && testDetail?.serverTime) {
            const data = remainTimeCalculator();
            timerRef.current = data.time;
            setCurrentSection(data.index || 0)
            if (data.index === 0 && (data.time + 5) >= data.perSectionTime && testDetail?.noOfSections > 1) {
                showToast(`Section ${sectionNumbers[data.index || 0]} started`)
            }

            let curentIndxing = JSON.parse(localStorage.getItem(`test${id}`))
            if (curentIndxing && curentIndxing.section == data.index) {
                localStorage.setItem(`test${id}`, JSON.stringify({ index: curentIndxing.index, section: data.index || 0 }))
            } else {
                localStorage.setItem(`test${id}`, JSON.stringify({ index: 0, section: data.index || 0 }))
            }
            setMainLoading(false)
        }
    }, [testDetail?.progress?.startTime, testDetail?.serverTime])



    useEffect(() => {
        let totalQuestion = mainQuestions.length;
        if (totalQuestion) {
            let eachSectionQuestion = parseInt(totalQuestion / totalSection);
            setEachSectionQuestion(eachSectionQuestion)
            let startIndex = currentSection * (eachSectionQuestion)
            let lastIndex = eachSectionQuestion * (currentSection + 1)
            setSectionWiseQuestion(mainQuestions.slice(startIndex, lastIndex))

        }
    }, [testDetail?.noOfSections, mainQuestions, totalSection, currentSection])

    const getInitilTime = () => {
        if ((testDetail.noOfSections ? testDetail?.noOfSections : 1) > 1) {
            return `Section ${sectionNumbers[currentSection]} Time Left : ${transform(0)}`;
        } else {
            return `Time Left : ${transform(0)}`;
        }
    }
    if (query1?.loading || query2.loading || mainLoading) return (<><Loader /></>)
    if (query1?.error) {
        if (query1?.error?.graphQLErrors.some((e) => e?.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1?.error?.graphQLErrors.some((e) => e?.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location?.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location?.pathname} />
                    </div>
                </div>
            </>)
        }

    }



    return (
        <>
            <section className="testFlow_wrapper">
                <div className="coursr_top_bar padding_bar d-flex justify-content-between">
                    <div className="course_name">
                        <p>{testDetail?.title || ""}</p>
                    </div>
                    <div className="view_instructions">
                        <span onClick={() => setQuestionPaperModal(true)}><img src={Icons.QuesPaper} alt="Question Paper" className="img-fluid" />View Question Paper</span>
                        <span onClick={() => setViewInstrutionsModal(true)}><img src={Icons.ViewInst} alt="View Instructions" className="img-fluid" />View Instructions</span>
                    </div>
                </div>
                <div className="attempt_division_wrapper d-flex">
                    <div className="division_first">
                        <div className="timer_bar padding_bar d-flex border_bottom">
                            <div className="section_ttl">
                                <p className="sections">Sections</p>
                            </div>
                            {/* time counter */}
                            <div className="timer text-center">
                                <p id="timer">
                                    {getInitilTime()}
                                </p>
                            </div>

                        </div>

                        {
                            !showSection &&
                            <div className="course_info border_bottom">
                                < span className="left_type"><img src={Images.LeftType} alt="View Info" className="img-fluid" /></span>
                                <span className="texts">{testDetail?.title || ""}<img src={Icons.ViewInst} alt="View Info" className="img-fluid" /></span>
                                <span className="right_type"><img src={Images.RightType} alt="View Info" className="img-fluid" /></span>
                            </div>
                        }
                        {showSection &&
                            <div className="course_info border_bottom">
                                < span className="left_type"><img src={Images.LeftType} alt="View Info" className="img-fluid" /></span>
                                {Array.from({ length: totalSection }, (_, index) => index).map(number => (
                                    <span className={` ${currentSection === number ? "texts" : "multiple_section"}`} key={number} onClick={() => curentSectionHandler(number, true)}>
                                        Section {sectionNumbers[number]}
                                    </span>
                                ))
                                }
                            </div>
                        }
                        <div className="question_type padding_bar border_bottom">
                            <p>Question Type: MCQ</p>
                        </div>
                        {
                            sectionWiseQuestion?.length > 0 ? (sectionWiseQuestion.map((question, i) => {
                                return index === i && <Question key={question._id} {...{ question, index: i, openImageModal, activeIndex: index, questionNextHandler, questionPreviousHandler, attemptedQuestion: attemptedQuestions[(currentSection * eachSectionQuestion) + i], currentSection, eachSectionQuestion }} />
                            })

                            ) : mainQuestions.map((question, i) => {
                                return index === i && <Question key={question._id} {...{ question, index: i, openImageModal, activeIndex: index, questionNextHandler, questionPreviousHandler, attemptedQuestion: attemptedQuestions[(currentSection * eachSectionQuestion) + i], currentSection, eachSectionQuestion }} />
                            })

                        }

                    </div>
                    <div className="division_second">
                        {/* user details */}
                        <UserDetail {...{ profileDetails }} />

                        {/* submit button with answer pallate */}
                        <AnswerPalette {...{ testDetail, switchQuestion, attemptedQuestions, totalSection, currentSection, eachSectionQuestion, sectionNumbers, showSection }} openSubmitModal={() => setTestSubmitModal(true)} />
                    </div>
                </div>
            </section >

            {/* question paper modal */}
            {
                questionPaperModal && (
                    <QuestionPaperModal show={questionPaperModal} onClose={() => setQuestionPaperModal(false)} mainQuestions={sectionWiseQuestion} />
                )
            }

            <Modal
                show={viewInstrutionsModal}
                onHide={() => setViewInstrutionsModal(true)}
                backdrop="static"
                className="question_papers_modal"
                centered
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Question Paper</h4>
                        <span className="cross_icon">
                            <img src={Icons.CrossW} alt="" className="img-fluid" onClick={() => setViewInstrutionsModal(false)} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="question_instructions" >

                        <div className="general_instructions" dangerouslySetInnerHTML={{ __html: `${query1.data ? query1?.data?.test?.instructions : ""}` }}>

                        </div>
                    </div>
                </Modal.Body>

            </Modal>
            <Modal
                show={testQuitModal}
                onHide={() => setTestQuitModal(false)}
                backdrop="static"
                className="detail_modal report_modal testReumse"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Your time is out!</h5>
                        <p>You cannot attempt this test now as you have run out of time. Click on View Performance to check your score</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={viewPerformance}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={viewPerformance}>View Performance</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={testSubmitModal}
                onHide={() => setTestSubmitModal(false)}
                backdrop="static"
                className="question_papers_modal"
                centered
            >
                <Modal.Body>
                    <div className="test_attempt_submit text-center">
                        <div className="submit_img">
                            <img src={Images.Warning} alt="" className="img-fluid" />
                        </div>
                        <h6>Are you sure you want to submit the Test?</h6>
                        <p>Once you submit the test you cannot reattempt the test. Are you sure you want to continue.</p>
                        <div className="submit_btns">
                            <button type="button" className="btn btn_theme" onClick={() => setTestSubmitModal(false)}>No</button>
                            <button type="button" className="btn btn_theme btn_border" onClick={() => totalresult()}>Yes</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={confirmationModal}
                onHide={() => setConfirmationModal(false)}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to quit this Test?</h5>
                        {/* <p>You can anytime come back and continue from where you left.</p> */}
                        <p>Your timer will keep running even if you quit.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={() => setConfirmationModal(false)}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={submitTest}>Yes, Quit</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={displayImageModal}
                onHide={imgHide}
                backdrop="static"
                className="detail_modal modelImgPopup"
                centered
                size="lg"
            >
                <Modal.Body>
                    <div className="Img_wrapper">
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={imgHide} />
                        </span>
                        <div className="img_popup">
                            <img src={selectedImage} alt="Popup Image" />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}